import { useRef } from "react";

// Stable ID per component instance. Use for SVG <defs> references
// (linearGradient, clipPath, filter, mask) so multiple instances on a page
// don't share the same id and collide.
let counter = 0;

const useUniqueId = (prefix = "uid") => {
  const idRef = useRef(null);
  if (idRef.current === null) {
    idRef.current = `${prefix}-${++counter}`;
  }
  return idRef.current;
};

export default useUniqueId;
